import { Header as HeaderLayout } from "@endya-conformite/ui-kit";
import Logo from "@endya-conformite/ui-kit/src/assets/logo.png";
import style from "./Header.module.scss";

export type HeaderProps = { title?: string };
export function Header({ title }: HeaderProps) {
  return (
    <HeaderLayout
      left={
        <>
          <img className={style.logo} src={Logo} alt="endya logo" />
          {title && <h2>{title}</h2>}
        </>
      }
    />
  );
}
